<template id="report">
  <div>
    <ReportItem label="1,00€" :item="report.reportp1" vvFormScope="reportp1"></ReportItem>
    <ReportItem label="5,00€" :item="report.reportp5" vvFormScope="reportp5"></ReportItem>
    <ReportItem label="10,00€" :item="report.reportp10" vvFormScope="reportp10"></ReportItem>      
  </div>
</template>
<script>
import ReportItem from './ReportTemplate1Item.vue'
export default {
  inject: ["$validator"],
  name: "report-component",
  template: "#report",
  props: {
    report: {
      type: Object
    },
    vvFormScope: {
      type: String
    }
  },
  filters: {
    ToUppercase: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    }
  },
  components: {
      ReportItem
  }
};
</script>